var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEscudoHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-primary)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.095,
    height: 126.295,
    viewBox: "0 0 124.095 126.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n.b{opacity:0.2;mix-blend-mode:multiply;isolation:isolate;}\n.c{fill:url(#a);}\n"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.184,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.047 0.572)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.047 -5.438)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1994.452-1305.216h0V-1412l36,4.831a1.91,1.91,0,0,1,1.675,1.866v13.12l15.826,3.6a1.888,1.888,0,0,1,1.5,1.834v26.356c0,22.682-14.346,43.039-36.132,51.269l-18.867,7.125Zm-18.868-3.911c-21.786-8.23-36.133-28.587-36.133-51.268v-26.357a1.889,1.889,0,0,1,1.5-1.834l15.826-3.6v-13.12a1.913,1.913,0,0,1,1.671-1.865l36-4.831v110Z",
    transform: "translate(2055 1417.438)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 -12.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 70.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M36.028,56.1C14.306,51.625,0,40.568,0,28.247V15.336c0-1.792,2.334-3.348,5.635-3.757l9.941-1.233v-4.1c0-1.927,2.689-3.558,6.3-3.822L55,0V0L88.128,2.422c3.612.264,6.3,1.9,6.3,3.822v4.1l9.94,1.233c3.3.41,5.631,1.967,5.63,3.757V28.247c0,12.319-14.306,23.377-36.028,27.847L55,60v0Z",
    transform: "translate(0 -0.156)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEscudoHover);
export default __webpack_public_path__ + "static/media/ico-escudo-hover.27cadc02da657a8c64b48defa901e66e.svg";
export { ForwardRef as ReactComponent };